import { waitFor } from "./wait-for";

const shopliftTesting = (element, data, isHidden = false) => {
  const hypothesisID = element?.dataset.hypothesis;

  const waitForShoplift = async () => {
    const shopliftReady = await new Promise((resolve) =>
      resolve(waitFor("shoplift"))
    );

    return shopliftReady;
  };

  const init = async () => {
    if (hypothesisID === undefined) return;

    try {
      await waitForShoplift().then(async () => {
        const active = await window.shoplift?.isHypothesisActive(hypothesisID);
        element.classList.remove("invisible", active);

        if (isHidden) {
          element.classList.remove("hidden", active);
        }

        element.style.display = !active ? "none" : "";
      });
    } catch (error) {
      console.error("[Shoplift testing]: Error during initialization.", error);
    }
  };

  init();
};

export { shopliftTesting };
